const url = process.env.END_POINT_URL;

export { url };
